import type { RouteLocation } from 'vue-router';

export function includesParams(
	outer: RouteLocation['params'],
	inner: RouteLocation['params'],
): boolean {
	for (const key in inner) {
		const innerValue = inner[key];
		const outerValue = outer[key];

		if (typeof innerValue === 'string') {
			if (innerValue !== outerValue)
				return false;
		}
		else {
			if (
				!Array.isArray(outerValue)
				|| outerValue.length !== innerValue?.length
				|| innerValue?.some((value, i) => value !== outerValue[i])
			) {
				return false;
			}
		}
	}

	return true;
}
